import { ProductType, PromotionTabsType } from '../../components/Layout/Promotions/PromotionsBlock/types';
import { PromoTypes } from '../../components/Layout/Promotions/types';
import { RootState } from '../store';

export const productTabName = (state: RootState): ProductType => state.promotions?.productTabName;
export const promotionTabName = (state: RootState): PromotionTabsType => state.promotions?.promotionTab;
export const loadPlatformPromotions = (state: RootState): boolean => state.promotions?.loadPlatformPromotions;
export const activePromoType = (state: RootState): PromoTypes | null => state.promotions?.activePromoType;
